import orderBy from 'lodash/orderBy';
import uniq from 'lodash/uniq';

import type { PracticeContactViewModel } from 'chaika-types';

interface PracticeDoctorIdsParams {
    practices: PracticeContactViewModel[];
    userId: string;
}

export function getMainPracticeDoctorIds({ practices, userId }: PracticeDoctorIdsParams): string[] {
    return getPracticeDoctorIds({ practices: practices.filter(({ isMain }) => isMain), userId });
}

export function getPracticeDoctorIds({ practices, userId }: PracticeDoctorIdsParams): string[] {
    const realPractices = practices.filter(({ realPractice }) => realPractice);
    const doctorIds = orderBy(realPractices, 'isMain', 'desc').flatMap(({ doctorIds = [] }) => doctorIds);

    return uniq(doctorIds).filter(doctorId => doctorId !== userId);
}
